import { initContract } from "@ts-rest/core";
import { stripeCreateConnectionBodySchema } from "@common/schemas/domains/stripe/stripe-connection.schema";
import { IntegrationConnectionDto } from "../dto/integrationConnection/integration-connection.dto";

const c = initContract();

export const stripeContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: stripeCreateConnectionBodySchema,
            responses: {
                201: c.type<IntegrationConnectionDto>(),
            },
        },
    },
    {
        pathPrefix: "/stripe",
    },
);
